const paramInput = /[^A-Za-z0-9\.\,\-\@\/\&\'\(\)\#\$\%\*\:\`\<\>\=\+\!\?]+/

function getMessage(field, args) {
  return `The ${field} consist of invalid characters.`
}

function validate(value, args) {
  if (value) {
    // if (paramInput.test(value)) {
    //   return false
    // } else {
    //   return true
    // }
    return !(paramInput.test(value))
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
